/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { DividerDefaults, DividerProps } from './Divider.props';

/**
 * SDS Divider component.
 */
export const Divider = (props: DividerProps): JSX.Element => {
  const { text, textAlignment, textSize } = {
    ...DividerDefaults,
    ...props,
  };

  const wrapperClass = clsx('sds-divider', `sds-divider--${textAlignment}`, {
    [`sds-divider--empty`]: !text,
  });

  const textClass = clsx('sds-text', `sds-text--${textSize}-semibold`);

  return <div className={wrapperClass}>{text && <span className={textClass}>{text}</span>}</div>;
};
